import axios from "axios";
import { FETCH_ALL_TRANSACTION_API } from "../Constants/Apis";

export const getTransactions = async () => {
  try {
    return axios.get(FETCH_ALL_TRANSACTION_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createTransaction = async (payload) => {
  try {
    return axios.post(FETCH_ALL_TRANSACTION_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const AggTransaction = async (payload) => {
  try {
    console.log(payload);
    return axios.post(`${FETCH_ALL_TRANSACTION_API}/agg_date`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const AggEcomTransaction = async (payload) => {
  try {
    return axios.post(`${FETCH_ALL_TRANSACTION_API}/agg_ecom_date`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const AggEcomTransactionCategory = async (payload) => {
  try {
    return axios.post(
      `${FETCH_ALL_TRANSACTION_API}/agg_ecom_category`,
      payload
    );
  } catch (e) {
    return console.log(e);
  }
};

export const AggEcomTransactionProductType = async (payload) => {
  try {
    return axios.post(`${FETCH_ALL_TRANSACTION_API}/agg_ecom_pt`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateTransaction = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_TRANSACTION_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteTransaction = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_TRANSACTION_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};
